// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"1b7a3c3606383be5f668","655":"3e0f29d1922dfbe3a454"}[chunkId] + ".js";
};